export interface TicketHours {
  // Tagesticket
  dayTicketSaleStart: number;
  dayTicketSaleEnd: number;
  dayTicketValidFrom: number;
  dayTicketValidUntil: number;

  // Nachmittagsticket
  afternoonSaleStart: number;
  afternoonSaleEnd: number;
  afternoonValidFrom: number;
  afternoonMaxUntil: number;

  // WOMO Übernachtung
  womoSaleStart: number;
  womoSaleEnd: number;

  // PKW + Caravan
  caravanSaleStart: number;
  caravanSaleEnd: number;

  // PKW Abstellen
  pkwNightSaleStart: number;
  pkwNightSaleEnd: number;

  // Shared overnight validity (WOMO, Caravan, PKW Abstellen)
  nightValidUntil: number;
}

export const DEFAULT_TICKET_HOURS: TicketHours = {
  dayTicketSaleStart: 7,
  dayTicketSaleEnd: 22,
  dayTicketValidFrom: 7,
  dayTicketValidUntil: 23,

  afternoonSaleStart: 14,
  afternoonSaleEnd: 22,
  afternoonValidFrom: 14,
  afternoonMaxUntil: 19,

  womoSaleStart: 18,
  womoSaleEnd: 22,

  caravanSaleStart: 18,
  caravanSaleEnd: 22,

  pkwNightSaleStart: 0,
  pkwNightSaleEnd: 23,

  nightValidUntil: 9,
};

export const DEFAULT_WINTER_TICKET_HOURS: TicketHours = {
  dayTicketSaleStart: 6,
  dayTicketSaleEnd: 22,
  dayTicketValidFrom: 6,
  dayTicketValidUntil: 22,

  afternoonSaleStart: 14,
  afternoonSaleEnd: 22,
  afternoonValidFrom: 14,
  afternoonMaxUntil: 19,

  womoSaleStart: 0,
  womoSaleEnd: 24,

  caravanSaleStart: 0,
  caravanSaleEnd: 24,

  pkwNightSaleStart: 0,
  pkwNightSaleEnd: 24,

  nightValidUntil: 9,
};

export type TicketHoursMode = "regular" | "winter";

export function getDefaultTicketHours(mode: TicketHoursMode = "regular"): TicketHours {
  return { ...(mode === "winter" ? DEFAULT_WINTER_TICKET_HOURS : DEFAULT_TICKET_HOURS) };
}

const END_KEYS = new Set<keyof TicketHours>([
  "dayTicketSaleEnd", "dayTicketValidUntil", "afternoonSaleEnd", "afternoonMaxUntil",
  "womoSaleEnd", "caravanSaleEnd", "pkwNightSaleEnd",
]);

export function isValidTicketHours(value: unknown): value is TicketHours {
  if (!value || typeof value !== "object") return false;
  const input = value as Record<string, unknown>;
  return (Object.keys(DEFAULT_TICKET_HOURS) as (keyof TicketHours)[]).every(key => {
    const hour = input[key];
    return typeof hour === "number" && Number.isInteger(hour) && hour >= 0 && hour <= (END_KEYS.has(key) ? 24 : 23);
  });
}

export function normalizeTicketHours(value: unknown, mode: TicketHoursMode): TicketHours {
  const hours = getDefaultTicketHours(mode);
  const input = value && typeof value === "object" ? value as Partial<TicketHours> : {};
  for (const key of Object.keys(hours) as (keyof TicketHours)[]) {
    const hour = input[key];
    if (typeof hour === "number" && Number.isInteger(hour) && hour >= 0 && hour <= (END_KEYS.has(key) ? 24 : 23)) hours[key] = hour;
  }
  return hours;
}
